import React from 'react';
import MobileLogin from '../../components/feature/mobile-login/index';
import { Container } from '@mui/material';
import UpdateAppModal from '../../components/common/update-app-modal';

const Login = () => {

    return <Container maxWidth="sm" fixed style={{ height: '100vh' }}>
        <MobileLogin />
        <UpdateAppModal page="login" />
    </Container>;
};

export default Login;
